import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./reset.css";

const Reset = () => {
  const [passwordData, setPasswordData] = useState({
    email: "",
    password: "",
    newPassword: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    const payload = {
      email: passwordData.email,
      password: passwordData.password,
      newPassword: passwordData.newPassword,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/check-email`,
        payload
      );

      if (response.status === 200) {
        alert("Password reset successful!");
        navigate("/");
      }
    } catch (error) {
      console.error("API Error:", error);
      setMessage(
        error.response?.data?.message ||
          "Password reset failed. Please check your credentials and try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reset-container">
      {/* Background truck and neutral vignette matching Login */}
      <img
        src="TruckImage.png"
        alt="Fleet Truck Background"
        className="reset-truck-bg"
      />
      <div className="reset-bg-overlay" />

      <form onSubmit={handleSubmit} className="reset-form">
        {/* Brand Logo Header */}
        <div className="reset-logo-header">
          <img
            src="almadinalog.png"
            alt="Al Madina Logistics"
            className="reset-logo"
          />
        </div>

        <h2 className="reset-title">Reset Password</h2>
        <p className="reset-subtitle">Enter your credentials to update your password</p>

        {message && <div className="reset-alert">{message}</div>}

        <div className="reset-input-box">
          <label>
            Email / Username <span className="reset-required">*</span>
          </label>
          <input
            type="text"
            name="email"
            placeholder="Enter your email or username"
            value={passwordData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="reset-input-box">
          <label>
            Old Password <span className="reset-required">*</span>
          </label>
          <input
            type="password"
            name="password"
            placeholder="Enter your current password"
            value={passwordData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="reset-input-box">
          <label>
            New Password <span className="reset-required">*</span>
          </label>
          <input
            type="password"
            name="newPassword"
            placeholder="Enter your new password"
            value={passwordData.newPassword}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="reset-button" disabled={isSubmitting}>
          {isSubmitting ? "Resetting..." : "Reset Password"}
        </button>

        <div className="reset-footer-links">
          <button
            type="button"
            className="reset-back-btn"
            onClick={() => navigate("/")}
          >
            <FaArrowLeft /> Back to Login
          </button>
        </div>

        <div className="reset-powered-by">
          <span>Powered by</span>
          <img
            src="bayanat.png"
            alt="Bayanat Technology"
            className="reset-powered-logo"
          />
        </div>
      </form>
    </div>
  );
};

export default Reset;
